/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import { mergeProps, useButton, useFocusRing, type AriaButtonOptions } from 'react-aria';
import cx from 'classnames';

interface NextPreviousButtonProps extends AriaButtonOptions<'button'> {
    children: React.ReactNode;
}

export function NextPreviousButton(props: NextPreviousButtonProps) {
    const ref = React.useRef<HTMLButtonElement>(null);
    const { buttonProps } = useButton(props, ref);
    const { focusProps, isFocusVisible } = useFocusRing();

    return (
        <button
            type="button"
            {...mergeProps(buttonProps, focusProps)}
            ref={ref}
            className={cx('next-prev-button', {
                'focus-visible': isFocusVisible,
                disabled: props.isDisabled,
            })}
        >
            {props.children}
        </button>
    );
}
